import React from 'react'

const Loading = () => {
  return (
    <div className='ring-container'>
        <div className='ring1'></div>
        <div className='ring2'></div>
    </div>
  )
}

export default Loading